import { Button } from "antd";
import formatPrice from "../../../components/formatPrice";
import datetimeParser from "../../../components/datetimeParser";
import DownloadXML from "./DownloadXML";
import CopyData from "../../../components/CopyData";
const columns = [
	{
		title: "ID wpływu",
		dataIndex: "msr_wplywy_own_id",
		width: "150px",
		key: "msr_wplywy_own_id",
		render: (item, record) => (
			<div className="monospace">
				<CopyData item={`#${item}`} />#{item}
			</div>
		),
	},
	{
		title: "Kwota przelewu",
		dataIndex: "msr_transfers_amount",
		key: "msr_transfers_amount",
		width: "200px",
		render: (item, record) => (
			<div
				className="monospace"
				style={{
					fontSize: "14px",
					fontWeight: 700,
					textAlign: "right",
				}}
			>
				{formatPrice(item)} zł
			</div>
		),
	},
	{
		title: "Imie i nazwisko osoby",
		dataIndex: "msr_transfers_amount",
		key: "msr_transfers_amount",
		render: (item, record) => (
			<div
				style={{
					fontSize: "14px",
					fontWeight: 500,
					display: "flex",
					gap: "10px",
				}}
			>
				<div
					style={{
						padding: "2px 5px",
						background: "rgb(233 233 233)",
						fontSize: "13px",
						color: "black",
						borderRadius: "5px",
						width: "fit-content",
						fontFamily: "Courier New, Courier, monospace",
						height: "fit-content",
					}}
				>
					#{record.msr_persons_own_id}
				</div>
				<div>
					{record.msr_persons_name} {record.msr_persons_lastname}
				</div>
			</div>
		),
	},
	{
		title: "ID transferu",
		dataIndex: "msr_transfers_own_id",
		width: "150px",
		key: "msr_wplywy_own_id",
		render: (item, record) => (
			<div className="monospace">
				<CopyData item={`#${item}`} />#{item}
			</div>
		),
	},
	{
		title: "Data wpływu na rachunek rozliczeniowy",
		dataIndex: "msr_wplywy_date_forward",
		key: "msr_wplywy_date_forward",
		render: (item, record) => (
			<div style={{ fontSize: "14px", fontWeight: 500 }}>
				{item && item != "null"
					? datetimeParser(item, "YYYY-MM-DD")
					: "Brak danych"}
			</div>
		),
	},
	{
		title: "Data zatwierdzenia",
		dataIndex: "msr_transfers_confirmed_datetime",
		key: "msr_transfers_confirmed_datetime",
		render: (item, record) => (
			<div style={{ fontSize: "14px", fontWeight: 500 }}>
				{datetimeParser(item, "YYYY-MM-DD")}
			</div>
		),
	},
	{
		title: "Pobierz XML",
		dataIndex: "msr_transfers_confirmed_datetime",
		key: "msr_transfers_confirmed_datetime",
		render: (item, record) =>
			record.msr_generated_files_id && (
				<DownloadXML
					fileName={record.msr_generated_files_name}
					generatedFileId={record.msr_generated_files_id}
				/>
			),
	},
];

export default columns;
